module.exports = __webpack_public_path__ + "static/img/indexText1.d09aeec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexText1.png
// module id = iAqy
// module chunks = 1